if (!customElements.get('rakhi-bundle-picker')) {
  customElements.define('rakhi-bundle-picker', class RakhiBundlePicker extends HTMLElement {
    constructor() {
      super();
      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId) || document.querySelector(`form[id="${this.formId}"]`) || document.querySelector('form[action*="/cart/add"]');
      
      this.kitOptions = this.querySelectorAll('.rakhi-kit-option');
      this.kitRadios = this.querySelectorAll('input[name="rakhi-kit-selection"]');
      this.charmCards = this.querySelectorAll('.rakhi-charm-card');
      this.charmCheckboxes = this.querySelectorAll('input[name="rakhi-charm-selection"]');
      this.hiddenPropertiesContainer = this.querySelector('#rakhi-hidden-properties');
      this.counterCurrent = this.querySelector('.rakhi-counter-current');
      this.counterMax = this.querySelector('.rakhi-counter-max');
      this.errorContainer = this.querySelector('.rakhi-bundle-errors');

      this.currentLimit = 3;
      this.selectedCharms = [];

      this.init();
    }

    init() {
      // Listen to kit selection
      this.kitRadios.forEach(radio => {
        radio.addEventListener('change', this.onKitChange.bind(this));
      });

      // Listen to charm selection
      this.charmCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.onCharmChange.bind(this));
      });

      // Initialize state from default checked radio
      const defaultChecked = this.querySelector('input[name="rakhi-kit-selection"]:checked');
      if (defaultChecked) {
        this.updateKitState(defaultChecked);
      } else if (this.kitRadios.length > 0) {
        this.kitRadios[0].checked = true;
        this.updateKitState(this.kitRadios[0]);
      }

      // Intercept form submit and button click using capture phase
      if (this.form) {
        this.form.addEventListener('submit', this.onFormSubmit.bind(this), true);
        const submitBtn = this.form.querySelector('[type="submit"], button.product-form__submit, button.add-to-cart, button[name="add"]');
        if (submitBtn) {
          submitBtn.addEventListener('click', this.onFormSubmit.bind(this), true);
        }
      }
    }

    onKitChange(event) {
      this.updateKitState(event.target);
    }

    updateKitState(radio) {
      // Update styling
      this.kitOptions.forEach(opt => opt.classList.remove('is-selected'));
      const label = radio.closest('.rakhi-kit-option');
      if (label) {
        label.classList.add('is-selected');
        this.currentLimit = parseInt(label.dataset.limit) || 3;
      }

      // Update counter UI
      if (this.counterMax) this.counterMax.textContent = this.currentLimit;

      // Update hidden variant ID input for the main form
      if (this.form) {
        let idInput = this.form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = radio.value;
        } else {
           // Some forms use select
           idInput = this.form.querySelector('select[name="id"]');
           if (idInput) idInput.value = radio.value;
        }
      }

      this.validateCharmSelection();
    }

    onCharmChange(event) {
      const checkbox = event.target;
      const card = checkbox.closest('.rakhi-charm-card');
      
      if (checkbox.checked) {
        if (this.selectedCharms.length >= this.currentLimit) {
          // Reached limit, prevent checking
          checkbox.checked = false;
          return;
        }
        this.selectedCharms.push(checkbox.value);
        card.classList.add('is-selected');
      } else {
        this.selectedCharms = this.selectedCharms.filter(val => val !== checkbox.value);
        card.classList.remove('is-selected');
      }

      // Update counter UI
      if (this.counterCurrent) this.counterCurrent.textContent = this.selectedCharms.length;

      this.validateCharmSelection();
    }

    validateCharmSelection() {
      // Hide error if they are selecting
      if (this.errorContainer) this.errorContainer.style.display = 'none';

      // Re-evaluate checkboxes, if we are at limit, disable unselected ones
      const atLimit = this.selectedCharms.length >= this.currentLimit;
      this.charmCheckboxes.forEach(cb => {
        if (!cb.checked) {
          cb.disabled = atLimit;
          const card = cb.closest('.rakhi-charm-card');
          if (atLimit) {
            card.style.opacity = '0.5';
            card.style.cursor = 'not-allowed';
          } else {
            card.style.opacity = '1';
            card.style.cursor = 'pointer';
          }
        }
      });

      // Update hidden properties
      this.updateHiddenProperties();
    }

    updateHiddenProperties() {
      if (!this.hiddenPropertiesContainer) return;
      this.hiddenPropertiesContainer.innerHTML = '';
      
      this.selectedCharms.forEach((charmName, index) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[Charm ${index + 1}]`;
        input.value = charmName;
        if (this.formId) {
          input.setAttribute('form', this.formId);
        }
        this.hiddenPropertiesContainer.appendChild(input);
      });
    }

    onFormSubmit(event) {
      if (this.selectedCharms.length !== this.currentLimit) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Forcefully revert any theme animations that might have triggered
        const submitBtn = this.form ? this.form.querySelector('button[name="add"], [type="submit"]') : null;
        if (submitBtn) {
          setTimeout(() => submitBtn.classList.remove('atc-added', 'loading'), 10);
        }

        if (this.errorContainer) {
          this.errorContainer.style.display = 'block';
          this.errorContainer.textContent = `Please select exactly ${this.currentLimit} charms. You have selected ${this.selectedCharms.length}.`;
        }
        // Scroll to the error
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        // Form will submit with the injected properties
        if (this.errorContainer) this.errorContainer.style.display = 'none';
      }
    }
  });
}
